import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { APICore } from '../helpers/api/apiCore';

const Root = () => {
    const api = new APICore();
    const { activeWorkspace } = useSelector((state: RootState) => state.Workspace);

    const getRootUrl = (): string => {
        if (!api.isUserAuthenticated()) {
            return 'auth/login';
        }
        
        // No workspace chosen yet (new user, or several to pick from): show the selector,
        // which offers "create workspace" when the user has none.
        const hasActiveWorkspace = activeWorkspace || localStorage.getItem('active_workspace');
        if (!hasActiveWorkspace) {
            return 'workspace/select';
        }
        return 'dashboard/ecommerce';
    };

    const url = getRootUrl();
    return <Redirect to={`/${url}`} />;
};

export default Root;
